import { Koleksi } from "@/types/shared.types";

export type GetKoleksiProps = {
  page?: number;
  rowsPerPage?: number;
  keyword?: string;
  start?: number;
  size?: number;
  filters?: {
    id: string;
    value: any;
  }[];
  globalFilter?: string;
  sorting?: {
    id: string;
    desc: boolean;
  }[];
  jenisPustaka?: string;
  accessToken?: string | null;
  bookmarked?: boolean;
  readOnline?: boolean;
};

export const getKoleksi = async ({
  page = 1,
  rowsPerPage = 10,
  keyword = '',
  start = 0,
  size = 10,
  filters = [],
  globalFilter = '',
  sorting = [],
  jenisPustaka = '',
  accessToken = '',
  bookmarked = false,
  readOnline = false
}: GetKoleksiProps) => {
  try {
    const fetchURL = new URL(`${process.env.NEXT_PUBLIC_API_URL}/v2/koleksi`);

    fetchURL.searchParams.set('start', String(start));
    fetchURL.searchParams.set('size', String(size));

    if (globalFilter) {
      fetchURL.searchParams.set('globalFilter', globalFilter);
    }

    if (filters.length > 0) {
      fetchURL.searchParams.set('filters', JSON.stringify(filters));
    }

    if (sorting.length > 0) {
      fetchURL.searchParams.set('sorting', JSON.stringify(sorting));
    }

    if (jenisPustaka) {
      fetchURL.searchParams.set('jenis-pustaka', jenisPustaka);
    }

    if (bookmarked) {
      fetchURL.searchParams.set('bookmarked', '1');
    }

    if (readOnline) {
      fetchURL.searchParams.set('readOnline', '1');
    }

    const response = await fetch(fetchURL.href, {
      headers: new Headers({
        Authorization: accessToken ? `Bearer ${accessToken}` : '',
      }),
    });

    return await response.json();
  } catch (error) {
    console.error(error);
    throw error;
  }
};